import { createBrowserRouter } from "react-router-dom";
import Home from "../components/sections/Home/Home";
import About from "../components/sections/About/About";
import App from "../App";
import Portfolio from "../components/sections/Portfolio/Portfolio";
import News from "../components/sections/News/News";
import Contact from "../components/sections/Contact/Contact";
import Error from "../components/sections/404.js/Error";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/portfolio",
        element: <Portfolio />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <Error/>,
      },
    ],
  },
]);

export default router;
